import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";
import CustomerForm from "../../components/Customers/CustomerForm";

const CustomersCreate = ({classes, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('boards.new_board')}
        />

        <Paper>
            <CardContent>
                <CustomerForm
                    formUrl={formUrl}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default CustomersCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/customers/Create.jsx